<template>
    <div class="commonTableStyles supplylist">
        <HeaderNav
            header-title="供应单"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <div class="search-con">
            <van-search
                placeholder="请输入搜索信息"
                v-model="keywords"
                @search="search"
            ></van-search>
        </div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                v-if="supplyList.length>0"
            >
                <ul class="list">
                    <li v-for="(item, index) in supplyList" :key="item.contract_number + index" :class="`status${item.supplier_state}`">
                        <div class="engineeringInfo">
                            <h4 class="engineeringInfo_header">
                                <span class="state">{{ item.supplier_state_name }}</span>
                                <span class="headerName">供应单{{ item.no }}</span>
                                <strong class="contractStatus">
                                    {{ item.supply_state_name }}
                                </strong>
                            </h4>
                            <div class="engineeringInfo_content">
                                <p>
                                    <span>物料名称：{{ item.goods_name }}</span>
                                </p>
                                <p>
                                    <span>子类：{{ item.type_name }}</span>
                                </p>
                                <p>
                                    <span>型号：{{ item.spec_name }}方</span>
                                </p>
                                <p>
                                    <span>接收场站：{{ item.station_name }}</span>
                                </p>
                                <p>
                                    <span>供应商：{{ item.supplier_name }}</span>
                                </p>
                                <p>
                                    <span>运输单位：{{ item.transport_name }}</span>
                                </p>
                                <p>
                                    <span>供应量：{{ item.supply_count }}</span>
                                </p>
                                <p>
                                    <span>已供应量：{{ item.supplied_count }}</span>
                                </p>
                                <p>
                                    <span>供应日期：{{ item.supply_date }}</span>
                                </p>
                            </div>
                        </div>
                        <div class="btn-con">
                            <div class="btn" @click.stop="viewWeighingDetails(item)">
                                <span>过磅明细</span>
                            </div>
                            <div class="btn" v-if="item.supply_state===0 || item.supply_state===2" @click.stop="handlePublish(item)">
                                <span>下发</span>
                            </div>
                            <div class="btn" @click.stop="handleAdjust(item)">
                                <span>调整</span>
                            </div>
                            <!-- <div
                                class="btn"
                                v-if="item.supply_state!==5 && item.supply_state !== 4&&item.balance_nums === 0"
                                @click.stop="handleCancel(item)"
                            >
                                <span>取消供应</span>
                            </div> -->
                            <div
                                class="btn"
                                v-if="item.supply_state!==5 && item.supply_state!==4 && item.onsite_nums===0"
                                @click.stop="handleComplate(item)"
                            >
                                <span>完成供应</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </van-list>
            <div class="no-data" v-show="supplyList.length===0"></div>
        </van-pull-refresh>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    name: 'supplylist',
    components: {
        HeaderNav,
    },
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'supplylist');
        }
        next();
    },
    data() {
        return {
            keywords: '',
            supplyList: [],
            loading: false,
            finished: false,
            page: {
                pageindex: 0,
                pagesize: 6,
            },
            refreshing: false,
        };
    },
    created() {
        this.onLoad();
    },
    methods: {
        getList() {
            this.$axios.get('/interfaceApi/procurement/daily/supply/get_supply_list'
            + `?pageindex=${this.page.pageindex}&pagesize=${this.page.pagesize}&searchKey=${this.keywords}`)
                .then(data => {
                    this.loading = false;
                    this.refreshing = false;
                    this.supplyList = this.supplyList.concat(data.rows);
                    if (this.supplyList.length >= data.total) {
                        this.finished = true;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        search() {
            this.page.pageindex = 0;
            this.supplyList = [];
            this.finished = false;
            this.onLoad();
        },

        onRefresh() {
            this.page.pageindex = 0;
            this.supplyList = [];
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        onLoad() {
            this.page.pageindex++;
            this.getList();
        },
        // 查看过磅明细
        viewWeighingDetails(item) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'poundList',
                params: {
                    task_number: item.no,
                    parentName: 'supplyList',
                },
            });
        },
        // 下发
        handlePublish(item) {
            this.$axios
                .get(`/interfaceApi/procurement/daily/supply/publish/${item.id}`,)
                .then(() => {
                    this.$toast('操作成功');
                    this.onRefresh();
                });
        },
        // 调整
        handleAdjust(item) {
            this.$router.isBack = 2;
            this.$router.push({
                path: '/supplyAdjust',
                query: {
                    supplyId: item.id,
                },
            });
        },
        // 取消供应
        handleCancel(item) {
            this.$axios
                .get(`/interfaceApi/procurement/daily/supply/cancel/${item.id}`,)
                .then(() => {
                    this.$toast('操作成功');
                    this.onRefresh();
                });
        },
        // 完成供应
        handleComplate(item) {
            this.$axios
                .get(`/interfaceApi/procurement/daily/supply/complete/${item.id}`,)
                .then(() => {
                    this.$toast('操作成功');
                    this.onRefresh();
                });
        },
    },
};
</script>

<style lang="stylus" scoped>
    .supplylist
        padding-top 44rpx
        height calc(100% - 44rpx)
        .newPlan
            position fixed
            right 20rpx
            top 10rpx
            z-index 1000
            color #fff
        .van-pull-refresh
            height calc(100% - 44rpx)
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            li
                &.status1
                    .contractStatus
                        color #FF6600
                    .state
                        background #FF6600
                &.status2
                    .state
                        background #E60000
                &.status3
                    .state
                        background #E60000
                &.status4
                    .state
                        background #FF6600
                &.status5
                    .contractStatus
                        color #04B97F
                    .state
                        background #04B97F
</style>
